import React, { useState, useEffect } from 'react';
import './GlobalSplashScreen.css';

const GlobalSplashScreen = ({ finished, onComplete }) => {
    const [stage, setStage] = useState(0); // 0: init, 1: loading, 2: exit

    useEffect(() => {
        // Start animation sequence
        const t1 = setTimeout(() => setStage(1), 100);
        return () => clearTimeout(t1);
    }, []);

    useEffect(() => {
        if (finished) {
            // Trigger exit animation
            const t2 = setTimeout(() => {
                setStage(2);
                // Remove from DOM after transition
                setTimeout(onComplete, 800);
            }, 500); // Shorter view time
            return () => clearTimeout(t2);
        }
    }, [finished, onComplete]);

    return (
        <div className={`splash-screen ${stage >= 2 ? 'exit' : ''}`}>
            <div className="splash-content">
                <div className="splash-logo-wrapper">
                    <img src="/images/logo.png" alt="Version Net" className="splash-logo" />
                    <div className="splash-ring ring-1"></div>
                    <div className="splash-ring ring-2"></div>
                </div>
                <div className="splash-text">
                    <span className="splash-title">VERSION NET</span>
                </div>
                <div className="splash-progress">
                    <div className={`splash-bar ${finished ? 'complete' : ''}`}></div>
                </div>
            </div>
        </div>
    );
};

export default GlobalSplashScreen;
